const ProgramTypes = [
  { id: 'camps_clinics', label: 'Camps/Clinics' },
  { id: 'club_teams', label: 'Club Teams' },
  { id: 'house_league', label: 'In House League' },
  { id: 'travel_league', label: 'Travel League' },
  { id: 'tournaments', label: 'Tournaments' },
  { id: 'other', label: 'Other' },
];

export default ProgramTypes;
